import { render } from "./ferry.vue?vue&type=template&id=e6a4fd8c"
import script from "./ferry.vue?vue&type=script&lang=js"
export * from "./ferry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__